import LaunchIcon from '@mui/icons-material/Launch';

export const ExternalRedirectIcon = () => (
  <LaunchIcon sx={{ marginLeft: '6px', marginBottom: '2px', verticalAlign: 'middle', fontSize: '1.28em' }} />
);
